import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CorporateService } from '../../_service/corporate.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
declare var $: any;
@Component({
  selector: 'app-corporate-lead-list',
  templateUrl: './corporate-lead-list.component.html',
  styleUrls: ['./corporate-lead-list.component.css']
})
export class CorporateLeadListComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';userId:string;corporate_leads:any=[];search:string;status:number;corporate_lead_status=[];
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;s3url:string='';submitted:boolean=false;corporateLeadsList:any=[];circles=[];circle='';bds_list=[];bd:string;start_date:string='';end_date:string='';
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('csvUploadFb', {static: false}) csvUploadFb: ElementRef;
  constructor(private leadapi:LeadsService,private corporateapi:CorporateService,private sharedapi:SharedService,private route:ActivatedRoute, private router: Router,private activatedRoute: ActivatedRoute, private elem: ElementRef) { }

  ngOnInit(): void {
    this.sharedapi.getRole();
    this.getCorporateStatusLists();
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.s3url = localStorage.getItem('s3url');
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');this.getbds();
    this.getcircle();
  }

  ngAfterViewInit() {
    this.loadCorporateLeads(0,this.perpage);
  }

  async getbds(status=1)
  {
    this.leadapi.getbdsofCorporate(status).subscribe((data:any) => {
        if(data.status)
        {
            this.bds_list = data.data;
        }else{
            this.bds_list = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.loadCorporateLeads(0,this.perpage);
      }
  }
  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.loadCorporateLeads(0,this.perpage);
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getCorporateStatusLists()
  {
    await this.corporateapi.getCorporateStatusLists().subscribe((data:any) => {
      if(data.status)
      {
        this.corporate_lead_status = data.data;
      }
      else
      {
        this.corporate_lead_status = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  

  async loadCorporateLeads(pageIndex,perpage)
  {
      this.corporate_leads = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&status='+this.status+'&circle='+this.circle+'&bd='+this.bd+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;
      this.loaded = false;
      this.corporateapi.getleadCorporateLists(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
            this.corporate_leads = data.data;
          }else{
            this.corporate_leads = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadCorporateLeads(event.pageIndex,event.pageSize);
  }

  hideModalFb()
  {
      $('#myModalfb').modal('hide');
  }

  showModalFb()
  {
      $('#myModalfb').modal();
  }

  async selectFileFb(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadcsvCorporateFb(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadFb.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalFb();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

}
